import * as Yup from "yup";
import { FormUtils } from "../../../../utils/forms";

export function generateValidation(validation) {
    return Yup.object().shape(
        validation.reduce((accumulator, field) => {
            return {
                ...accumulator,
                [field.name]: field.validationSchema
                    ? FormUtils.generateYupValidatorFromSchema(
                          field.validationSchema
                      )
                    : field.validation
            };
        }, {})
    );
}

export function createValidation(schema: any, required) {
    return Object.keys(schema)
        .reverse()
        .map(keyName => {
            schema[keyName].type = Array.isArray(schema[keyName].type)
                ? schema[keyName].type[0]
                : schema[keyName].type;

            return {
                name: keyName,
                validationSchema: {
                    ...schema[keyName],
                    required: required.includes(keyName) ? true : false
                }
            };
        });
}

export function validateChildren(
    child,
    progressiveValidationSchema,
    prizeValidationSchema
) {
    const prizes = child.prizes;

    try {
        progressiveValidationSchema.validateSync(child);
    } catch (e) {
        return false;
    }

    if (
        (child.type == "easylink" ||
            child.type == "multipots" ||
            child.type == "jumbolink" ||
            child.type == "luckytokenslink" ||
            child.type == "reelstrike" ||
            child.type == "sap") &&
        (child.preset === "" || child.preset === undefined || child.preset === null)
    ) {
        return false;
    }

    if (
        (child.game_groups == undefined ||
            (Array.isArray(child.game_groups) &&
                child.game_groups.length == 0)) &&
        (child.terminal_groups == undefined ||
            (Array.isArray(child.terminal_groups) &&
                child.terminal_groups.length == 0))
    ) {
        return false;
    }

    // Validate Child Prizes
    for (let i = 0; i < prizes.length; i++) {
        if (!validatePrize(prizes[i], prizeValidationSchema)) return false;
    }

    return true;
}

// Validate Prize
export function validatePrize(prize, prizeValidationSchema) {
    try {
        prizeValidationSchema.validateSync(prize);
    } catch (e) {
        return false;
    }
    return true;
}

// Validate Progressive
export function validateProgressive(
    progressive,
    progressiveValidationSchema,
    prizeValidationSchema
) {
    if ((progressive.type !== "multipots" && progressive.type !== "reelstrike" &&
        (
            (Array.isArray(progressive.coin) && progressive.coin.length == 0) ||
            progressive.coin == undefined ||
            progressive.coin == null
        ))
    ) {
        return false;
    }

    try {
        progressiveValidationSchema.validateSync(progressive);
    } catch (e) {
        return false;
    }

    if (
        (progressive.type == "easylink" ||
            progressive.type == "multipots" ||
            progressive.type == "jumbolink" ||
            progressive.type == "levels" ||
            progressive.type == "sap") &&
        (progressive.preset == "" || progressive.preset == undefined)
    ) {
        return false;
    }

    // Validate Prizes
    const prizes = progressive.prizes;
    for (let i = 0; i < prizes.length; i++) {
        if (!validatePrize(prizes[i], prizeValidationSchema)) return false;
    }

    // Validate Children
    const children = progressive.children;
    for (let i = 0; i < children.length; i++) {
        if (
            !validateChildren(
                children[i],
                progressiveValidationSchema,
                prizeValidationSchema
            )
        )
            return false;
    }

    return true;
}

export function validateWays(
    values,
    progressiveValidationSchema,
    prizeValidationSchema
) {
    for (let i = 0; i < values.length; i++) {
        if (
            !validateProgressive(
                values[i],
                progressiveValidationSchema,
                prizeValidationSchema
            )
        )
            return false;
    }

    return true;
}
